import bg from '../assets/bg.png';
import logo from '../assets/logo.png';
import menu from '../assets/menu.png';
import overlaybg from '../assets/overlaybg.png';
import line from '../assets/line.svg';
import welcome from '../assets/welcome.png';
import findus from '../assets/findus.png';
import quote from '../assets/quote.png';
import gericht from '../assets/gericht.png';
import ttd from '../assets/ttd.png';
import ps from '../assets/ps.png';
import chair from '../assets/chair.png';
import pole from '../assets/pole.png'
import service from '../assets/service.png'
import hairrepair from '../assets/Hair Repair.png'
import gentle from '../assets/Gentleman.png'
import kids from '../assets/kids.png'
import tatto from '../assets/tatto.png'
import color from '../assets/color.png'
import smooth from '../assets/smoothing.png'
import perm from '../assets/perm.png'
import hair1 from '../assets/hair1.jpg'
import hair2 from '../assets/hair2.jpg'
import hair3 from '../assets/hair3.jpg'
import hair4 from '../assets/hair4.jpg'


const images = {
  bg,
  logo,
  menu,
  overlaybg,
  line,
  welcome,
  findus,
  quote,
  gericht,
  ttd,
  ps,
  chair,
  pole,
  service,
  hairrepair,
  gentle,
  kids,
  tatto,
  color,
  smooth,
  perm,
  hair1,
  hair2,
  hair3,
  hair4,
};

export default images;
